import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction, ProfitItemData } from '@frontend/api';

export type UseQuoteProfitItemsParams = {
  componentIds: number[];
  quoteId: string;
};

export type QuoteProfitItemsQueryKey = readonly [
  'quotes',
  'profitItems',
  UseQuoteProfitItemsParams,
];

export const getQuoteProfitItemsQueryKey = (
  params: UseQuoteProfitItemsParams,
): QuoteProfitItemsQueryKey => ['quotes', 'profitItems', params];

export const useQuoteProfitItems: QueryFunction<
  ProfitItemData[],
  [UseQuoteProfitItemsParams],
  QuoteProfitItemsQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getQuoteProfitItemsQueryKey(params);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/quotes/${params.quoteId}/list_profit_items`, {
        init: {
          signal,
          method: 'GET',
        },
        query: { componentIds: params.componentIds },
      }),
  });
};
